module.exports = __webpack_public_path__ + "static/media/404.77e1571b.svg";